module.exports = __webpack_public_path__ + "static/img/pending-boost.f075e95.svg";


//////////////////
// WEBPACK FOOTER
// ./static/image/activity-boost/pending-boost.svg
// module id = ycsb
// module chunks = 1